import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse } from '@angular/common/http';
import { LoaderService } from './Loader/loader.service';

const maxAge = 300;
@Injectable()
export class RequestCache {
  constructor(private loaderService: LoaderService) {
  }
  cache = new Map();
  get(req: HttpRequest<any>): HttpResponse<any> | undefined {
    const url = req.urlWithParams;
    const cached = this.cache.get(url);
    //console.log(cached);
    if (!cached) {
      return undefined;
    }
    //console.log(this.cache)
    const isExpired = cached.lastRead < (Date.now() - maxAge);
    const expired = isExpired ? 'expired ' : '';
    this.hideLoader();
    return cached.response;
  }
  put(req: HttpRequest<any>, response: HttpResponse<any>): void {
    const url = req.url;
    const entry = { url, response, lastRead: Date.now() };
    this.cache.set(url, entry);
    const expired = Date.now() - maxAge;
    this.cache.forEach(expiredEntry => {
      if (expiredEntry.lastRead < expired) {
        this.cache.delete(expiredEntry.url);
      }
    });
  }
  private hideLoader(): void {
    setTimeout(() => {
      this.loaderService.hide();
    }, 0);
  }
}
